/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Banners
 *
 * 2 = FeaturesList
 *
 * 3 = TextBlock
 *
 * 4 = TNC
 *
 * 5 = LinkButtons
 *
 * 6 = VideoModule
 *
 * 7 = CallUsModule
 *
 * 8 = PeriodModule
 *
 * 10 = FixedModule
 *
 * 11 = EventPeriodModule
 *
 * 12 = CarOffersModule
 *
 * 13 = FeaturesWithIconsModule
 */
export enum TemplateBlockTypeEnum {
  Banners = 1,
  FeaturesList = 2,
  TextBlock = 3,
  TNC = 4,
  LinkButtons = 5,
  VideoModule = 6,
  CallUsModule = 7,
  PeriodModule = 8,
  FixedModule = 10,
  EventPeriodModule = 11,
  CarOffersModule = 12,
  FeaturesWithIconsModule = 13,
}
